import { neon } from '@/services/neon'

export interface Product {
  id: string
  type: 'plan' | 'addon'
  name: string
  price: number
  recurrence: 'monthly' | 'one-time'
  is_active: boolean
  sort_order: number
}

export async function fetchProducts(): Promise<Product[]> {
  const { data, error } = await neon
    .from('products')
    .select('*')
    .eq('is_active', true)
    .order('sort_order', { ascending: true })

  if (error) throw new Error(error.message)
  return (data as Product[]) || []
}

export async function fetchProductByName(name: string): Promise<Product | null> {
  const { data, error } = await neon
    .from('products')
    .select('*')
    .eq('name', name)
    .eq('is_active', true)
    .single()

  if (error) return null
  return data as Product
}
